module.exports = __webpack_public_path__ + "media/images/WHATSAPP-b03d88ab747d32c4213d0407bc901515.svg";